import axios from '@/axios.js'

export default {
  fetchDataListItems ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/outlaycategory/data')
        .then((response) => {
          commit('SET_OUTLAYCATEGORIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/outlaycategory/update', {item})
        .then((response) => {
          commit('UPDATE_OUTLAYCATEGORIES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/outlaycategory/create', {item})
        .then((response) => {
          commit('CREATE_OUTLAYCATEGORIES', Object.assign(response.data.data, {id: response.data.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
